import React from 'react'

import { CardContent } from '@/shared/components/ui/card'

export default function WidgetContent({
	children,
	className,
	...props
}: {
	children: React.ReactNode
	className?: string
} & React.HTMLAttributes<HTMLDivElement>) {
	return (
		<CardContent className={className} {...props}>
			{children}
		</CardContent>
	)
}
